import { useReducer } from 'react';
import type { ObjectAccessUser } from '@/types/workspace.access';
import { ObjectAccessStateContext } from './Context';
import type { ObjectAccess } from './interfaces';

type Props =
  ChildrenProps;

const initialState: ObjectAccess.State = {
  object: null,
  initial: [],
  items: [],
};

export const ObjectAccessState = (props: Props) => {
  const reducer = useReducer(objectAccessReducer, initialState);

  return (
    <ObjectAccessStateContext.Provider value={reducer}>
      {props.children}
    </ObjectAccessStateContext.Provider>
  );
};

function objectAccessReducer(state: ObjectAccess.State, action: ObjectAccess.Actions): ObjectAccess.State {
  switch (action.type) {
    case 'add':
      return {
        ...state,
        items: [
          ...state.items,
          action.value,
        ],
      };

    case 'load':
      return {
        object: action.object,
        initial: action.items,
        items: action.items,
      };

    case 'remove':
      return {
        ...state,
        items: state.items
          .filter(f => f.user.id !== action.userId),
      };

    case 'update-role':
      return {
        ...state,
        items: state.items.reduce<ObjectAccessUser[]>((acc, x) => ([
          ...acc,
          {
            roleId: action.userId === x.user.id
              ? action.roleId
              : x.roleId,
            user: x.user,
          },
        ]), []),
      };

    case 'access-saved': {
      return {
        ...state,
        initial: state.items,
      };
    }

    default:
      return state;
  }
}

export default ObjectAccessState;